export const privacy_policy =
  "https://1drv.ms/w/s!AorSD7QGs4ZyfgiHQPOlTn1MPSg?e=QynjHG";

export const terms_conditions =
  "https://1drv.ms/w/s!AorSD7QGs4ZygQIeuoZQvpYsUKEe?e=zcbl2h";
